import type { ReactNode } from 'react';
import { memo } from 'react';

type ItemHeaderProps = {
  title: ReactNode;
  right?: ReactNode;
};

export const ItemHeader = memo((props: ItemHeaderProps) => {
  const { title, right = null } = props;
  return (
    <div className="flex items-center">
      <div className="w-[3px] bg-[#3370ff] h-[14px] mr-[6px] flex-shrink-0"></div>
      <div className="flex item-center justify-between flex-grow">
        <div className="text-[#232426] font-bold">{title}</div>
        {right}
      </div>
    </div>
  );
});
